import ButtonOutline from "kreate-common/modules/kreate-ui/components/ButtonOutline";
import ButtonPrimary from "kreate-common/modules/kreate-ui/components/ButtonPrimary";
import CircularProgress$Indeterminate from "kreate-common/modules/kreate-ui/components/CircularProgress/components/CircularProgress$Indeterminate";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import ModalV2 from "kreate-common/modules/kreate-ui/components/ModalV2";
import React from "react";

import CollectorRow from "./components/CollectorRow";
import styles from "./index.module.scss";

import { useIsGonnaVisible } from "@/modules/common-hooks/useIsGonnaVisible";
import ErrorViewer from "@/modules/kreate-components/components/ErrorViewer";
import { useCollectorListInfinite } from "@/modules/resources/hooks/useCollectorListInfinite";

type Props = {
  open: boolean;
  onClose?: () => void;
  params$GetCollectors?: {
    artworkId?: string | undefined;
    collectionId?: string | undefined;
    userId?: string | undefined;
  };
};

export default function ModalCollectorListViewer({
  open,
  onClose,
  params$GetCollectors,
}: Props) {
  const [buttonLoadMoreEl, setButtonLoadMoreEl] =
    React.useState<Element | null>(null);
  const isButtonLoadMoreGonnaBeVisible = useIsGonnaVisible({
    element: buttonLoadMoreEl,
    rootMargin: "0px",
  });

  const collectorListSWR = useCollectorListInfinite({
    ...params$GetCollectors,
  });

  const shouldLoadMoreNow =
    isButtonLoadMoreGonnaBeVisible &&
    !collectorListSWR.computed.isLoadingMore &&
    !collectorListSWR.computed.isEnded &&
    !!collectorListSWR.loadMore;

  React.useEffect(() => {
    if (shouldLoadMoreNow) {
      collectorListSWR.loadMore?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldLoadMoreNow]);

  return (
    <ModalV2 open={open} onClose={onClose}>
      <ModalV2.Header content="Collected by" />
      <ModalV2.Content>
        <Flex.Col gap="24px">
          {collectorListSWR.data?.map(({ collectors }) =>
            collectors.map((collector) => (
              <CollectorRow key={collector.address} collector={collector} />
            ))
          )}
        </Flex.Col>
        {collectorListSWR.error ? (
          <ErrorViewer error={collectorListSWR.error} />
        ) : undefined}
        {collectorListSWR.computed.isLoadingMore ? (
          <Flex.Row alignItems="center" justifyContent="center" padding="24px">
            <CircularProgress$Indeterminate
              className={styles.colorPrimary}
              size="48px"
            />
          </Flex.Row>
        ) : collectorListSWR.computed.isEmpty ? (
          <Flex.Row alignItems="center" justifyContent="center" padding="24px">
            <div className={styles.disabledText}>{"No collectors"}</div>
          </Flex.Row>
        ) : collectorListSWR.computed.isEnded ? (
          <Flex.Row alignItems="center" justifyContent="center" padding="24px">
            {collectorListSWR.computed.totalCount &&
            collectorListSWR.computed.totalCount > collectorListSWR.LIMIT ? (
              <div className={styles.disabledText}>{"No more collectors"}</div>
            ) : undefined}
          </Flex.Row>
        ) : (
          <Flex.Row alignItems="center" justifyContent="center" padding="24px">
            <ButtonOutline
              ref={setButtonLoadMoreEl}
              content="Load More"
              disabled={!collectorListSWR.loadMore}
              onClick={collectorListSWR.loadMore}
            />
          </Flex.Row>
        )}
      </ModalV2.Content>
      <ModalV2.Actions>
        <ButtonPrimary content="Close" onClick={onClose} />
      </ModalV2.Actions>
    </ModalV2>
  );
}
